import React, { useState, useEffect, useContext } from 'react';
import { Segment, Dimmer, Loader, Button } from 'semantic-ui-react';
import submitToFevirServer from './SubmitToFevirServer';
import { loadNotifications } from './NotificationsFunctions';

const NotificationsView = ({ globalContext }) => {
    const [initialLoaded, setInitialLoaded] = useState(false);
    const [notificationsEditedState, setNotificationsEditedState] = useState(false);
    const [notificationsState, setNotificationsState] = useState(null);
    //notificationsState array consists of { userid: number, message: string, classifier: string, target: FOI, unread: boolean, uncleared: boolean, time: Date }

    const updateNotifications = async () => {
        if (notificationsEditedState) {
            const body = {
                "functionid": "updateuserspecificnotifications",
                "notifications": notificationsState,
                "idToken": ""
            }

            let response = await submitToFevirServer(globalContext, 30000, body, true, false);

            if (response?.success) {
            } else { alert("Problem submitting updated user notification status data."); }
        }
        setNotificationsEditedState(false);
    };

    const loadAndSetNotifications = async () => {
        let notifications = await loadNotifications(globalContext);
        if (notifications) {
            setNotificationsState(notifications || []);
        }
        if (!initialLoaded) {
            setInitialLoaded(true);
        }
        if (globalContext.newNotificationBoolean) {
            globalContext.setNewNotificationBoolean(false);
        }
    }

    useEffect(async () => {
        //When the user visits the page while signed in this will load their notifications
        //Or if there's a signal sent from the server since the page loaded saying there are new notifications
        //Then load the notification list
        if ((!initialLoaded && globalContext.userState.id) || globalContext.newNotificationBoolean) {
            loadAndSetNotifications();
        }
        //The else if is not necessary because this component is unmounted upon logout, and mounted again upon login, so the state is cleared
        /* else if (!globalContext.userState.loading) {
          setNotificationsState([]);
          setNotificationsEditedState(false);
        } */
    }, [globalContext.userState.id, globalContext.newNotificationBoolean]);

    useEffect(() => {
        updateNotifications();
    }, [notificationsEditedState]);

    return <div>
        {notificationsState?.length
            ?
            <>{notificationsState.map((notification, index) => {
                return <p key={index}>
                    {notification.uncleared ?
                        <>
                            <span style={{ fontWeight: notification.unread ? "bold" : "" }}>
                                {((notification.classifier === "resource-updated" || notification.classifier === "referenced-resource-updated") && notification.target) ?
                                    <a href={"/" + notification.target}>{notification.message}</a>
                                    :
                                    notification.message
                                }
                            </span>
                            &nbsp;&nbsp;{notification.timeString}  <span>
                                <Button className="formButton"
                                    style={{ color: "#000000", padding: "4px" }}
                                    content={notification.unread ? "Mark Read" : "Mark Unread"}
                                    onClick={() => {
                                        setNotificationsState(prevState => {
                                            let newUnread = !prevState[index].unread;
                                            prevState[index].unread = newUnread;
                                            if (newUnread) {
                                                globalContext.setNumberUnreadNotifications(prevState => (prevState + 1));
                                            } else {
                                                globalContext.setNumberUnreadNotifications(prevState => (prevState - 1));
                                            }
                                            return prevState;
                                        });
                                        setNotificationsEditedState(true);
                                    }} />
                            </span>  <span>
                                <Button className="formButton"
                                    style={{ color: "#000000", padding: "4px" }}
                                    content="Remove"
                                    onClick={() => {
                                        setNotificationsState(prevState => {
                                            prevState[index].uncleared = false;
                                            prevState[index].unread = false;
                                            globalContext.setNumberUnreadNotifications(prevState => (prevState - 1));
                                            globalContext.setNumberUnclearedNotifications(prevState => (prevState - 1));
                                            return prevState;
                                        });
                                        setNotificationsEditedState(true);
                                    }} />
                            </span>
                        </>
                        :
                        "Notification deleted."}
                </p>
            })}</>
            :
            <p>{!notificationsState ? "Loading..." : "You do not have any notifications."}</p>
        }
    </div>
}

export default NotificationsView;